// Versión de assets de contenido mutable (banners de curso /courses/*, imagen
// de marca /services/*). Estos archivos tienen nombre FIJO (no hasheado por
// Vite), así que el service worker / navegador podrían servir versiones
// obsoletas tras cambiarlos. Añadir `?v=ASSET_VER` cambia la URL y fuerza a
// traer la versión nueva sin depender de recargas ni del bump del SW.
//
// ⬆️ Súbelo cada vez que reemplaces un banner de curso, la imagen RoboTeam o
//    una carátula de robot de la tienda (/robots/*).
export const ASSET_VER = '13';

export function withAssetVer(url: string | null | undefined): string {
  if (!url) return '';
  return url.includes('?') ? `${url}&v=${ASSET_VER}` : `${url}?v=${ASSET_VER}`;
}
